
export function useFallback() {

    const localeStore = useLocaleStore()

    const fallback = (localizedEntry, lang = null) => {

        const selectedLanguage       = localeStore.getSelectedLanguage()

        if (!localizedEntry) {
            return ''
        }

        if(typeof localizedEntry !== 'object'){
            return localizedEntry
        }

        let currentLanguage = lang || selectedLanguage

        if (localizedEntry[currentLanguage]) {
            return localizedEntry[currentLanguage]
        }

        for(const locale of localeStore.locales){
            if (localizedEntry[locale.code]) {
                return localizedEntry[locale.code]
            }
        }

        // Fallback finale: restituisce il primo valore disponibile
        const values = Object.values(localizedEntry)
        if (values.length) return values[0]

        return ''
    }

    return {
        fallback
    }
}